// extracted by mini-css-extract-plugin
export var card = "_sq-0";